import {useContentCards, useContentCardActions} from "@irati/braze"
import React, {useState} from "react"
import GenericModal from "../../GenericModal"
import {Banner} from "./Banner"
import {Popup} from "./Popup"

export default function ContentCards() {
  const [isPopupShown, setIsPopupShown] = useState(false)
  const {banners} = useContentCards()
  const {markContentCardClicked} = useContentCardActions()

  const banner = banners.find(({extras: {showOnPages, banner: b}}) => {
    if (b?.position !== "top") return false
    if (!showOnPages && !location.pathname.startsWith("/admin")) return true
    if (showOnPages?.some((page) => location.pathname.startsWith("/" + page))) return true
    return false
  })

  const popup = banner?.extras?.popup

  return (
    <div>
      {banner && (
        <Banner
          banner={banner.extras.banner}
          popup={popup}
          onClick={() => {
            if (banner.extras.banner.hideIf === "clicked") {
              markContentCardClicked(banner.id)
            }
            if (popup) {
              setIsPopupShown(true)
            }
          }}
        />
      )}
      {popup && (
        <GenericModal hideActions show={isPopupShown} onHide={() => setIsPopupShown(false)}>
          <Popup
            popup={popup}
            onClick={() => {
              if (popup.hideIf === "clicked") {
                markContentCardClicked(popup.id)
              }
              setIsPopupShown(false)
            }}
          />
        </GenericModal>
      )}
    </div>
  )
}
